export default function SplashScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div
        role="status"
        aria-label="Loading"
        className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-slate-300 border-t-slate-600"
      />
    </div>
  );
}
